import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'm-detail-title',
  template: `
    <p class="m-detail-title">
      {{ mTitle }}
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MDetailTitleComponent {
  @Input() mTitle = '';
}
